import { render } from "./AgSegmentModalComponent.vue?vue&type=template&id=59e56f8c&scoped=true&ts=true"
import script from "./AgSegmentModalComponent.vue?vue&type=script&lang=ts"
export * from "./AgSegmentModalComponent.vue?vue&type=script&lang=ts"

import "./AgSegmentModalComponent.vue?vue&type=style&index=0&id=59e56f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e56f8c"]])

export default __exports__